import { FC, MouseEventHandler, PropsWithChildren, ReactNode } from 'react';
import { noop } from 'utils/noop';
import { PrimaryOptionText, PrimaryOptionStyled } from './QuickNav.styles';

export interface PrimaryOptionProps {
  /** Function to call when the mouse enters the Option */
  onMouseEnter?: MouseEventHandler<HTMLButtonElement>;
  /** Function to call when clicked */
  onClick?: MouseEventHandler<HTMLButtonElement>;
  /** Displayed Text */
  title?: ReactNode;
  /** if hover state should be forced */
  hover?: boolean;
  children?: JSX.Element;
}

export const PrimaryOption: FC<PropsWithChildren<PrimaryOptionProps>> = ({
  onClick = noop,
  onMouseEnter = noop,
  title = '',
  hover = false,
  children,
  ...props
}: PrimaryOptionProps) => {
  return (
    <PrimaryOptionStyled
      tabIndex={0}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      id={typeof title === 'string' ? title : undefined}
      $hover={hover}
      data-test="quick-nav-primarymenuoption"
      {...props}
    >
      <PrimaryOptionText data-test="quick-nav-primarymenuoption-text">{title}</PrimaryOptionText>
      {children}
    </PrimaryOptionStyled>
  );
};
